export const UPLOAD_DOCUMENT_HELP_LINK =
  'https://help.goodstack.org/what-bank-account-details-are-required'
